function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTaskStatisticsDetailList } from '@/api/task';
import { taskCodeOptions, taskTypeOptions, rewardTypeOptions } from '../enums';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    appId: {
      type: [String, Number],
      default: ''
    },
    statDate: {
      type: [String, Number],
      default: ''
    },
    taskCode: {
      type: [String, Number],
      default: ''
    },
    taskType: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    formData: function formData() {
      return [{
        label: '用户ID',
        prop: 'userId',
        defaultValue: '',
        type: 'input'
      }];
    },
    columns: function columns() {
      return [{
        key: 'logId',
        visible: true,
        label: "ID",
        width: 100
      }, {
        key: 'application',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 120
      }, {
        key: 'taskCode',
        visible: true,
        label: "\u4EFB\u52A1\u7F16\u7801",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: taskCodeOptions
        }
      }, {
        key: 'taskType',
        visible: true,
        label: "\u4EFB\u52A1\u7C7B\u578B",
        width: 120,
        formatter: 'text',
        formatOptions: {
          list: taskTypeOptions
        }
      }, {
        key: 'userInfo',
        visible: true,
        label: "\u7528\u6237",
        width: 130
      }, {
        key: 'createTime',
        visible: true,
        label: "\u5F00\u59CB\u65F6\u95F4",
        width: 160
      },
      // { key: 'status', visible: true, label: `是否成功`, width: 80 },
      {
        key: 'rewardType',
        visible: true,
        label: "\u5956\u52B1\u7C7B\u578B",
        width: 80,
        formatter: 'text',
        formatOptions: {
          list: rewardTypeOptions
        }
      }, {
        key: 'rewardValue',
        visible: true,
        label: "\u5956\u52B1\u6570\u503C",
        width: 100
      }];
    }
  },
  watch: {
    value: {
      handler: function handler(newV) {
        if (newV) {
          this.init();
        }
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    init: function init() {
      var _this = this;
      this.$nextTick(function () {
        _this.resetList();
      });
    },
    handleClose: function handleClose() {
      this.$emit('input', false);
      this.list = [];
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), {}, {
        statDate: this.statDate,
        applicationId: this.appId,
        taskCode: this.taskCode,
        taskType: this.taskType
      });
      return getTaskStatisticsDetailList(params).then(function (data) {
        var list = (data.list || []).map(function (item) {
          return _objectSpread({}, item);
        });
        return {
          list: list,
          total: data.total
        };
      });
    }
  }
};